var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBusinessLogoIvon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1479_7393)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2868 0.750977H2.71445C1.21739 0.750977 0 1.96797 0 3.46679V20.5359C0 22.033 1.21739 23.2487 2.71445 23.2487H21.2868C22.7838 23.2487 23.9999 22.033 23.9999 20.5359V3.46679C24 1.96797 22.7839 0.750977 21.2868 0.750977ZM15.5196 4.78992C16.9673 4.78992 18.1414 5.96409 18.1414 7.41173C18.1414 8.85938 16.9673 10.0336 15.5196 10.0336C14.0715 10.0336 12.8978 8.85938 12.8978 7.41173C12.8978 5.96409 14.0715 4.78992 15.5196 4.78992ZM20.4356 20.7395H11.9998H3.9398C3.21569 20.7395 2.89321 20.2156 3.21963 19.5693L7.71916 10.6572C8.04518 10.0109 8.66653 9.95321 9.10655 10.5282L13.631 16.4409C14.071 17.016 14.8401 17.0649 15.3491 16.5497L16.456 15.4289C16.9646 14.9137 17.714 14.9774 18.1291 15.5704L20.9953 19.6645C21.4096 20.2584 21.1597 20.7395 20.4356 20.7395Z",
    fill: "#4F565E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1479_7393"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessLogoIvon);
export default __webpack_public_path__ + "static/media/business-logo-ivon.a689b1734ddc83be584cd40ec88999d8.svg";
export { ForwardRef as ReactComponent };